import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { alertCategories, type EmailAlerts } from "@/hooks/useEmailAlerts";

export function EmailAlertSettings({ value, onChange, error }: {
  value: EmailAlerts;
  onChange: (value: EmailAlerts) => void;
  error: string | null;
}) {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Email Alerts</CardTitle>
        <CardDescription>Choose which changes to the current Klatsch you want to hear about.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">
        {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
        <fieldset disabled={!!error} className="space-y-4">
          <legend className="sr-only">Changes to include in email alerts</legend>
          {alertCategories.map(([key, label]) => (
            <div key={key} className="flex items-center space-x-2">
              <Checkbox id={`alert-${key}`} checked={value[key]}
                onCheckedChange={checked => onChange({ ...value, [key]: checked === true })} />
              <Label htmlFor={`alert-${key}`}>{label}</Label>
            </div>
          ))}
          <div className="space-y-2 pt-2">
            <Label htmlFor="alert-email">Email:</Label>
            <Input id="alert-email" type="email" autoComplete="email" maxLength={254}
              value={value.email ?? ""} onChange={event => onChange({ ...value, email: event.target.value })} />
          </div>
        </fieldset>
        <p className="text-xs text-muted-foreground">
          Alerts are sent after the person making changes has been inactive for 30 minutes.
          Leave all boxes unchecked to turn alerts off.
        </p>
        <p className="text-xs text-muted-foreground">
          Some Other Change includes article removal or reordering, comment edits or deletions,
          recommendations, and advancing the issue.
        </p>
      </CardContent>
    </Card>
  );
}
